import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-artwork-investor',
  templateUrl: './artwork-investor.component.html',
  styleUrls: ['./artwork-investor.component.scss']
})
export class ArtworkInvestorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
